import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AjaxHelper } from '../helper/ajax.helper';
import { BaseResponse } from '../model/base.response';
import { WebConstants } from '../util/web.constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PaymentDetailSearchService {
  public baseUrl: string = environment.BaseServiceUrl;

  constructor(public ajaxHelper: AjaxHelper,
    private httpClient: HttpClient) {
  }
  getGatewayDataDetailByLP(licensePlate: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.GATEWAY_DATA_DETAIL_SEARCH.FIND_GATEWAY_DATA_DETAIL_BY_LP + licensePlate);
  }
  getPaymentDetailByLP(licensePlate: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.PAYMENT_DETAIL_SEARCH.FIND_PAYMENT_DETAIL_BY_LP + licensePlate);
  }
  getPermitDetailByLP(licensePlate: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.PERMIT_DETAIL_SEARCH.FIND_PERMIT_DETAIL_BY_LP + licensePlate);
  }
  getPaymentDetailByLPFromApi(licensePlate: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.PAYMENT_DETAIL_API.FIND_PAYMENT_DETAIL_FROM_API + licensePlate);
  }
  getPermitDetailByLPFromApi(licensePlate: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.PERMIT_DETAIL_API.FIND_PERMIT_DETAIL_FROM_API + licensePlate);
  }

  getPassportData(){
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.PERMIT_DETAIL_API.FIND_ALL_TODAY);
  }
  getPaymentData(){
    let currentEpoch = new Date();
    let epochToDateTime = currentEpoch.toLocaleString('en-us');
    let currentDateTime = epochToDateTime.split(',')[0];
    let currentDate = currentDateTime.replace(/[/]/g,'-') + " 00:00:00";

    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.PAYMENT_DETAIL_API.FIND_ALL_TODAY + "/" + "09-27-2022 00:00:00");
  }
}
